import { IconType } from "~/common/components/icon/IconType";

export const CaseStatus = {
  NEW: "serviceCases.status.new",
  IN_PROGRESS: "serviceCases.status.pending",
  CLOSED: "serviceCases.status.closed",
} as const;

export const CaseIcon = {
  NEW: IconType.EnvelopeOpen,
  IN_PROGRESS: IconType.Clock,
  CLOSED: IconType.Check,
} as const;

export type CaseStatusKeys = keyof typeof CaseStatus;

export interface CaseDataObject {
  code: string;
  sfCaseNumber: string;
  status: CaseStatusKeys;
  completeData: boolean;
  reasonOfRequest: string;
  createdAt: string;
  updatedAt: string;
}
